<div class="dropdown-wrapper">
    <section class="field">
        @if (label()) {
            <span class="label">{{ label() }}</span>
        }
        <lib-generic-dropdown
            [source]="source()"
            [config]="config()"
            [placeholder]="placeholder()"
            [disabled]="disabled() || isReadOnly()"
            [noResultsText]="noResultsText()"
            [error]="error()"
            [selectedItem]="selectedItem"
            (selectedItemChange)="onSelectionChange($event)"
        >
        </lib-generic-dropdown>
    </section>
    <section class="errorField"></section>
</div>
